module.exports = __webpack_public_path__ + "static/media/telenyainen.d9569a1e.jpg";